import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { messages } from './messages';

export const AlertType = ({ alertType }) => {
  return (
    <div>
      <FormattedMessage {...messages[alertType]} />
    </div>
  );
};

AlertType.propTypes = {
  alertType: PropTypes.string.isRequired,
};
